<template>
  <v-form ref="user_form">
    <v-card class="custom-border">
      <v-card-title class="primary white--text">
        {{ $t('group.create_user_group') }}
      </v-card-title>
      <v-card-text class="my-4 pt-4">
        <v-row>
          <v-col
            cols="12"
            class="py-0"
          >
            <v-text-field
              ref="input-0"
              v-model.trim="userGroup.name_jp"
              :label="`${$t('group.user_group_name')} *`"
              :rules="[validationFunction(userGroup.name_jp, true, 256)]"
              :counter="256"
              type="text"
              outlined
              dense
              @focus="currentIndex = 0"
              @keydown.enter="focusNext"
            />
          </v-col>
          <v-col
            cols="12"
            class="py-0"
          >
            <v-textarea
              ref="input-1"
              v-model.trim="userGroup.desc_jp"
              :label="`${$t('group.user_group_description')} *`"
              :rules="[validationFunction(userGroup.desc_jp, true, 512)]"
              :counter="512"
              type="text"
              outlined
              dense
              @focus="currentIndex = 1"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-btn
          outlined
          color="primary"
          :disabled="loading"
          :loading="loading"
          @click="onCreateUserGroup"
        >
          {{ $t('group.create') }}
        </v-btn>
        <v-btn
          outlined
          color="complimentary"
          :disabled="loading"
          :loading="loading"
          @click="onCancelUserGroup"
        >
          {{ $t('common.cancel') }}
        </v-btn>
      </v-card-actions>
      <v-alert
        v-model="errorState"
        dense
        type="error"
        dismissible
        class="mb-0 custom-alert-border"
      >
        {{ error }}
      </v-alert>
    </v-card>
  </v-form>
</template>

<script>
import QUATSError from '../plugins/error'

export default {
  data() {
    return {
      loading: false,
      userGroup: {
        name_jp: '',
        desc_jp: ''
      },
      currentIndex: 0,
      error: null,
      errorState: false
    }
  },

  methods: {
    onCancelUserGroup() {
      this.$emit('createUserGroupCancel')
      this.onCloseDialog()
    },

    onCloseDialog() {
      this.$refs.user_form.reset()
      this.userGroup= {
        name_jp: '',
        desc_jp: ''
      }
    },

    onCreateUserGroup() {
      if (this.$refs.user_form.validate()) {
        const data = {}
        for (const userGroupKey in this.userGroup) {
          !this.userGroup[userGroupKey] || (data[userGroupKey] = this.userGroup[userGroupKey])
        }

        const promises = [
          window.axios.post('/api/group/user-groups/', data)
        ]

        Promise.all(promises)
          .then(() => {
            this.$emit('createUserGroupSuccess')
            this.onCloseDialog()
            this.errorState = false
          })
          .catch(err => {
            console.warn('error', err)
            this.error = new QUATSError(this.$i18n, err).message
            this.errorState = true
          })
          .finally(() => this.loading = false)
      }
    },

    /**
     * @desc to move employee creation form focus to the next
     */
    focusNext() {
      this.currentIndex += 1
      const nextElement = this.$refs[`input-${this.currentIndex}`]
      if (nextElement) nextElement.focus()
    },

    /***
     * @desc validation function to make the validation rule code shorter than using compute since there are lots of common between each field
     * @param v value of the field
     * @param require boolean value if the field is required
     * @param length maximum length of the field allow, don't passed any value if not necessary to check for length
     * @returns {VueI18n.TranslateResult|boolean}
     */
    validationFunction(v, require, length = 0) {
      if (length !== 0 && v.length > length) {
        return this.$t('common.maximum_text', {length: length})
      } else if (require && !v) {
        return this.$t('common.required')
      } else {
        return true
      }
    }
  }
}
</script>

<style scoped>
.custom-border {
  border-width: 0;
}
.custom-alert-border {
  font-size: 80%;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
</style>
